(function () {
  if (window.lopBuyNowBound) return;
  window.lopBuyNowBound = true;

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-lop-buy-now]');
    if (!button || button.getAttribute('aria-disabled') === 'true') return;

    var form = button.closest('form');
    if (!form) return;

    var addButton = form.querySelector('.single-add-to-cart-button');
    if (addButton && (addButton.disabled || addButton.classList.contains('sold-out'))) return;

    var idInput = form.querySelector('[name="id"]');
    var variantId = idInput && idInput.value;
    if (!variantId) return;

    event.preventDefault();
    button.classList.add('loading');
    button.setAttribute('aria-disabled', 'true');

    var body = new FormData(form);
    body.set('id', variantId);
    body.delete('sections');
    body.delete('sections_url');

    var cartAddUrl = (window.theme && theme.routes && theme.routes.cart_add_url) || '/cart/add.js';
    var cartUrl = (window.theme && theme.routes && theme.routes.cart_url) || '/cart';

    fetch(cartAddUrl, {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json'
      },
      body: body
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok || (result.data && result.data.status)) {
          button.classList.remove('loading');
          button.removeAttribute('aria-disabled');
          var message = (result.data && (result.data.description || result.data.message)) || 'No se pudo agregar el producto';
          var wrapper = form.closest('product-form');
          var error = wrapper && wrapper.querySelector('.product-form__error-message');
          var errorWrap = wrapper && wrapper.querySelector('.product-form__error-message-wrapper');
          if (error && errorWrap) {
            error.textContent = message;
            errorWrap.removeAttribute('hidden');
          }
          return;
        }
        window.location.href = cartUrl;
      })
      .catch(function () {
        button.classList.remove('loading');
        button.removeAttribute('aria-disabled');
      });
  });
})();
